<template>
  <img
    src="/mc-logo.png"
    alt="morningcrunch"
    height="40"
    width="93"
  />
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
